/* src/app/weighbridge/pages/weighbridge-yard-trade-edit/weighbridge-yard-trade-edit.component.scss */
/*# sourceMappingURL=weighbridge-yard-trade-edit.component.css.map */
